/* src/app/components/dashboard/dashboard.component.css */
:root {
  --primary-color: #3498db;
  --secondary-color: #2ecc71;
  --background-color: #ecf0f1;
  --text-color: #2c3e50;
  --border-color: #bdc3c7;
  --font-size-small: 0.875rem;
  --font-size-medium: 1rem;
  --font-size-large: 1.25rem;
  --spacing-small: 0.5rem;
  --spacing-medium: 1rem;
  --spacing-large: 2rem;
  --border-radius-small: 0.25rem;
  --border-radius-medium: 0.5rem;
  --border-radius-large: 1rem;
}
body {
  font-family: Arial, sans-serif;
  color: var(--text-color);
  background-color: var(--background-color);
}
button {
  background-color: var(--primary-color);
  color: #fff;
  padding: var(--spacing-medium) var(--spacing-large);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-medium);
  font-size: var(--font-size-medium);
}
button:hover {
  background-color: var(--secondary-color);
}
.go-live-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  align-self: stretch;
  padding: 2rem;
}
.go-live-banner {
  width: 100%;
  max-width: 680px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 76, 74, 0.18);
  background: #ffffff;
  border: 1px solid rgba(0, 76, 74, 0.15);
}
.go-live-banner__header {
  background:
    linear-gradient(
      135deg,
      #004c4a 0%,
      #00847f 100%);
  padding: 1.25rem 1.75rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.go-live-banner__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  flex-shrink: 0;
}
.go-live-banner__icon i {
  font-size: 1.375rem;
  color: #ffffff;
}
.go-live-banner__headline {
  margin: 0 0 0.25rem;
  font-size: 1.1875rem;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.3;
}
.go-live-banner__tagline {
  margin: 0;
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.82);
}
.go-live-banner__body {
  padding: 1.25rem 1.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;
  background: #fafffe;
}
.go-live-banner__message {
  color: #475569;
  font-size: 0.9375rem;
  line-height: 1.65;
  margin: 0;
  flex: 1;
  min-width: 220px;
}
.go-live-banner__message strong {
  color: #004c4a;
  font-weight: 600;
}
.go-live-banner__date-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f0fafa;
  border: 2px solid #004c4a;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  flex-shrink: 0;
  min-width: 148px;
  gap: 0.25rem;
}
.go-live-banner__date-badge-icon {
  font-size: 1.25rem;
  color: #004c4a;
  margin-bottom: 0.25rem;
}
.go-live-banner__date-label {
  font-size: 0.6875rem;
  font-weight: 700;
  color: #004c4a;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.go-live-banner__date-value {
  font-size: 1rem;
  font-weight: 700;
  color: #004c4a;
  text-align: center;
  line-height: 1.3;
}
.role-popover {
  min-width: 280px;
  max-width: 320px;
  max-height: 500px;
  overflow-y: auto;
}
.role-popover__header {
  padding: 1rem 1rem 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}
.role-popover__title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
}
.role-popover__subtitle {
  margin: 0;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.5;
}
.role-popover__subtitle strong {
  color: #004c4a;
  font-weight: 600;
}
.role-list {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.role-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: #ffffff;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.role-item:hover {
  background: #f8fafc;
  border-color: #004c4a;
  transform: translateX(2px);
}
.role-item:hover .role-item__icon {
  background:
    linear-gradient(
      135deg,
      #004c4a 0%,
      #00847f 100%);
}
.role-item:hover .role-item__icon i {
  color: #ffffff;
}
.role-item:hover .role-item__arrow {
  color: #004c4a;
  transform: translateX(2px);
}
.role-item:focus {
  outline: none;
  border-color: #004c4a;
  box-shadow: 0 0 0 2px rgba(0, 76, 74, 0.15);
}
.role-item:active {
  transform: translateX(1px);
}
.role-item__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #e2e8f0;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.role-item__icon i {
  font-size: 1rem;
  color: #475569;
  transition: color 0.2s ease;
}
.role-item__name {
  flex: 1;
  font-size: 0.95rem;
  font-weight: 500;
  color: #1e293b;
}
.role-item__arrow {
  color: #cbd5e1;
  transition: all 0.2s ease;
  font-size: 0.875rem;
}
/*# sourceMappingURL=dashboard.component-6BSFSELO.css.map */
